module.exports = __webpack_public_path__ + "static/media/icon-other.4cefff7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/icon-other.svg
// module id = 549
// module chunks = 0